import {
    Armchair,
    Coffee,
    Plug,
    Printer,
    Table,
    UsersRound,
    Wifi,
    Wind
} from "lucide-react";

export const AMENITIES = [
    { label: "Ergonomic chairs", labelKey: "spaceAmenities.chair", value: "12", icon: Armchair, key: "chair" },
    { label: "Work desks", labelKey: "spaceAmenities.table", value: "8", icon: Table, key: "table" },
    { label: "Meeting room", labelKey: "spaceAmenities.meetingRoom", value: "1", icon: UsersRound, key: "meeting-room" },
    { label: "Fast WiFi", labelKey: "spaceAmenities.wifi", value: "1 Gbps", icon: Wifi, key: "wi-fi" },
    { label: "AC & ventilation", labelKey: "spaceAmenities.ac", value: "Full", valueKey: "spaceAmenitiesValues.full", icon: Wind, key: "ac" },
    { label: "Coffee station", labelKey: "spaceAmenities.coffee", value: "Unlimited", valueKey: "spaceAmenitiesValues.unlimited", icon: Coffee, key: "refreshments" },
    { label: "Power outlets", labelKey: "spaceAmenities.powerOutlets", value: "Every desk", valueKey: "spaceAmenitiesValues.everyDesk", icon: Plug, key: "power-outlets" },
    { label: "Printer", labelKey: "spaceAmenities.printer", value: "On-site", valueKey: "spaceAmenitiesValues.onSite", icon: Printer, key: "printer" }
];

// Keep the hourly flow available in code for a future rollout without exposing it to customers.
export const HOURLY_BOOKINGS_ENABLED = false;

export const SPACES = [
    {
        id: "b7ab7cfe1cb6b7ef7b272e5700d15b70ec425da8c889e5b8a22920adc656d9f7",
        title: "TX Real",
        location: "PSSSF Tower, Dar es Salaam",
        rating: 4.5,
        img: "https://res.cloudinary.com/dorkbt39x/image/upload/v1765321863/meets-N-works/TX-REAL/2_MG_9911_TX_REAL_garden_avenue_tower_tueess.png"
    },
    {
        id: "c93ff5adda8491ff5037a3808ab691b501a67241099cac5fbe28cfd221dd33fb",
        title: "TX Lone",
        location: "PSSSF Tower, Dar es Salaam",
        rating: 4.0,
        img: "https://res.cloudinary.com/dorkbt39x/image/upload/v1765328636/meets-N-works/TX-LONE/_MG_9926_TX_LONE_garden_avenue_tower_xwrsky.jpg"
    },
    {
        id: "728ad240a6c90b3df528b7c76ebd8c071fb998eccbe020b6c3e3a98c8696ce58",
        title: "MN Coon",
        location: "PSSSF Tower, Dar es Salaam",
        rating: 4.8,
        img: "https://res.cloudinary.com/dorkbt39x/image/upload/v1765322170/meets-N-works/MN-COON/DSC02825_MN_COON_commercial_tower_kue2ul.png"
    },
    {
        id: "bad01f337848a84f8ce0e2b74744b2c98287456dcb5818a1b69013d62bf2d6a0",
        title: "CA Napa",
        location: "PSSSF Tower, Dar es Salaam",
        rating: 4.3,
        img: "https://res.cloudinary.com/dorkbt39x/image/upload/v1765321651/meets-N-works/CA-NAPA/DSC02854_CA_NAPA_commercial_tower_ie8se0.png"
    },
    {
        id: "721a2a3f086051dc4d2064e49ebb3691663dbdbe7e9eb3280e4a5f15311a3e7e",
        title: "CA Ross",
        location: "PSSSF Tower, Dar es Salaam",
        rating: 4.7,
        img: "https://res.cloudinary.com/dorkbt39x/image/upload/v1765321962/meets-N-works/CA-ROSS/DSC02795_CA_ROSS_commercial_tower_rlipmr.png"
    },
];

export const MENU_ITEMS = [
    {
        labelKey: "menu.aboutUs",
        path: "/",
        section: "about",
        visibility: "public"
    },
    {
        labelKey: "menu.howItWorks",
        path: "/",
        section: "how-it-works",
        visibility: "public"
    },
    {
        labelKey: "menu.ourSpaces",
        path: "/spaces",
        section: null,
        visibility: "public"
    },
    {
        labelKey: "menu.faqs",
        path: "/",
        section: "faqs",
        visibility: "public"
    },
    {
        labelKey: "menu.signIn",
        path: "/login",
        section: null,
        visibility: "public"
    },
    {
        labelKey: "menu.bookings",
        path: "/dashboard/bookings",
        section: null,
        visibility: "private"
    },
    {
        labelKey: "menu.customers",
        path: "/dashboard/customers",
        section: null,
        visibility: "private"
    },
    {
        labelKey: "menu.spaces",
        path: "/dashboard/spaces",
        section: null,
        visibility: "private"
    },
    {
        labelKey: "menu.payments",
        path: "/dashboard/payments",
        section: null,
        visibility: "private"
    },
    {
        labelKey: "menu.signOut",
        path: "/",
        section: null,
        visibility: "private"
    },
];

export const ROLES = {
    USER: "user",
    ADMIN: "admin",
};
